import React from "react";
import {useWelcomeAssistantContext} from "./ContextType";
import {Slide} from "@mui/material";

export function Slider(props: { children: any, nr: number }) {
    const {slideDirection, currentStage} = useWelcomeAssistantContext();

    return <Slide direction={props.nr >= currentStage ? 'left' : 'right'} in={props.nr == currentStage} mountOnEnter unmountOnExit>
        <div style={{width: '100%'}}>
            {props.children}
        </div>
    </Slide>
}
